module.exports = __webpack_public_path__ + "img/CENTRIF_SALA.4053114c.jpg";